module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture29-3d42dfb3a07cdae6332034e04d31f876.jpg";